module.exports = __webpack_public_path__ + "img/bg_pc.66ef5452.webp";